import { Component } from '@angular/core';
import {AppService} from './app.service'
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../environments/environment';
@Component({
  selector: 'prelogin-form',
  providers: [AppService],  
  styleUrls: ['./prelogin.component.css'],
  template: `
    <div class="prelogin-container">
        <div class="prelogin-card">
            <h1 class="prelogin-title">Login</h1>
            
            <div class="form-group">
                <label class="form-label">Mobile Number</label>
                <input 
                    class="form-input" 
                    type="tel"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    placeholder="Enter your mobile number"
                    [(ngModel)]="preloginData.phone" 
                />
                <div class="form-hint">Example: 4915212345678</div>
            </div>
            
            <div class="form-group">
                <label class="form-label">PIN</label>
                <input 
                    class="form-input" 
                    type="password"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    maxlength="4"
                    placeholder="Enter your 4-digit PIN"
                    (keyup.enter)="preLogin()" 
                    [(ngModel)]="preloginData.pin"
                />
            </div>
            
            <div class="captcha-container">
                <!-- ng7-recaptcha (captchaResponse)="handleCorrectCaptcha($event)" size="invisible" site_key="{{captcha_key}}"></!-->
            </div>
            
            <button class="prelogin-button" (click)="preLogin()" type="submit">
                Login
            </button>
            
            <div class="action-links">
                <button class="register-link" (click)="register()" type="button">
                    Don't have an account? Register
                </button>
            </div>
            
            <ngx-spinner size="medium" [type]="typeSelected"></ngx-spinner>
        </div>
    </div>`
})
export class PreLoginComponent {
    public preloginData = { "phone":"", "pin":"", "recaptchaResponse":""}
    typeSelected: string;
    captcha_key: string;
    ACTION = 'login'; // modifica se vuoi: 'signup', 'submit_form', ecc.
    private captchaRetries = 0;
    private maxRetries = 50; // 10 secondi (50 * 200ms)


    constructor(private _service:AppService, private _router: ActivatedRoute, private router: Router, private spinnerService: NgxSpinnerService) {
        this.typeSelected = 'ball-fussion';
        this.captcha_key = environment.captcha_key;
    }

    ngOnInit() {
        this.preloginData.phone = this._router.snapshot.params['username'];
        this.preloginData.pin = this._router.snapshot.params['password'];

        // Sottoscrizione per rigenerare il captcha quando c'è un errore
        this._service.regenerateCaptcha$.subscribe(() => {
            this.regenerateCaptcha();
        });

        // Aspetta che il DOM sia completamente caricato
        if (document.readyState === 'complete') {
            this.requestRecaptchaV3Token();
        } else {
            window.addEventListener('load', () => {
                setTimeout(() => this.requestRecaptchaV3Token(), 500);
            });
        }
    }

    requestRecaptchaV3Token(): void {
        // Verifica se window.grecaptcha esiste
        const globalgrecaptcha = (window as any).grecaptcha;

        if (typeof globalgrecaptcha === 'undefined' || !globalgrecaptcha || !globalgrecaptcha.enterprise) {
            this.captchaRetries++;
            if (this.captchaRetries >= this.maxRetries) {
                console.error('reCAPTCHA script failed to load after ' + this.maxRetries + ' retries');
                // Imposta un token vuoto per permettere comunque il login
                // il backend gestirà la validazione
                this.preloginData.recaptchaResponse = 'captcha-load-failed';
                return;
            }
            console.log('grecaptcha not loaded yet, retrying... (' + this.captchaRetries + '/' + this.maxRetries + ')');
            setTimeout(() => this.requestRecaptchaV3Token(), 200);
            return;
        }

        try {
            globalgrecaptcha.enterprise.ready(() => {
                globalgrecaptcha.enterprise.execute(environment.captcha_key, { action: this.ACTION })
                    .then((token: string) => {
                        this.preloginData.recaptchaResponse = token;
                        console.log('reCAPTCHA v3 token:', token);
                    })
                    .catch((error: any) => {
                        console.error('reCAPTCHA execute error:', error);
                        this.preloginData.recaptchaResponse = 'captcha-execute-failed';
                    });
            });
        } catch (error) {
            console.error('reCAPTCHA ready error:', error);
            this.preloginData.recaptchaResponse = 'captcha-ready-failed';
        }
    }

    regenerateCaptcha(): void {
        // Reset dei retry e rigenera il token
        this.captchaRetries = 0;
        console.log('Regenerating captcha token...');
        this.requestRecaptchaV3Token();
    }

    handleCorrectCaptcha(captchaRes: string) {  
        console.log(`Resolved response token: ${captchaRes}`);
        this.preloginData.recaptchaResponse = captchaRes;
        //this.preloginData.recaptchaResponse = this.captcha.getResponse();
        console.log(this.preloginData);
        // this.captcha.reset();
        this._service.preLogin(this.preloginData);

     }

    public showSpinner(): void {
        this.spinnerService.show();
    
        // setTimeout(() => {
        //  this.spinnerService.hide();
        // }, 5000); // 5 seconds
      }

    register() {
        this.router.navigate(['/register']);
    }

    preLogin() {
        
        this.showSpinner()
        if (this.preloginData.phone.indexOf('+') != -1 ) {
            this.preloginData.phone = this.preloginData.phone.substring(1);
        }
        if (this.preloginData.phone.substring(0,2) == "00") {
            this.preloginData.phone = this.preloginData.phone.substring(2);
        }

        console.log(this.preloginData);
        this._service.preLogin(this.preloginData);
        
        // this.captcha.execute();
        //this.preloginData.recaptchaResponse = this.captcha.getResponse();
        //console.log(this.preloginData);
        //this._service.preLogin(this.preloginData);
    }
}
